import React, { useRef, useState } from "react";
// Import your audio file
import audioFile from "/audio/lazy-village.mp3";

export default function Audio() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [started, setStarted] = useState(false);

  const audioRef = useRef();

  // Function to toggle audio playback
  const toggleAudio = () => {
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  };

  addEventListener(
    "mousedown",
    function (e) {
      if (!started) {
        toggleAudio();
        setStarted(true);
      }
    },
    { once: true }
  );

  return (
    <div className="interface">
      <audio ref={audioRef} src={audioFile} loop />
      <button
        className={isPlaying ? "audio-button audio-on" : "audio-button"}
        onClick={toggleAudio}
      >
        {isPlaying ? "Pause Music" : "Play Music"}
      </button>
    </div>
  );
}


